/**
 * Centralized React Query key factory.
 * Always call through these functions — never hardcode key strings in components or hooks.
 */
export const queryKeys = {
  artists: {
    all: () => ['artists'],
    page: (page) => ['artists', page],
    detail: (id) => ['artist', id],
  },
  events: {
    all: () => ['events'],
    page: (page) => ['events', page],
    detail: (id) => ['event', id],
    landing: () => ['landingEvents'],
  },
  info: () => ['info'],
  youtubeTitle: (url) => ['youtubeTitle', url],
};
